import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'
import { addMinutes, parseISO } from 'date-fns'

// get first and last date of the data
function getBounds(array) {
  const arr = sortBy(array, 'x')
  return [arr[0], arr[arr.length - 1]]
}

function createEventMap(item, timelineOverviewMap, eventName) {
  for (const [i, event] of item.entries()) {
    const { timestamp, releasable, ...rest } = event
    if (timestamp && releasable) {
      const updatedTimestamp = parseISO(timestamp.slice(0, -5))
      // adding n minutes to avoid overlapping events
      const updatedDate = addMinutes(new Date(updatedTimestamp), i + 1).toISOString()
      const data = {
        timestamp: updatedTimestamp,
        x: updatedDate,
        y: 0,
        id: `${i}-${rest.name || rest.description}`,
        ...rest
      }
      timelineOverviewMap.get(eventName).data.push(data)
    }
  }
}

export const formatTimelineData = (technique) => {
  const timelineOverviewObject = {
    'Technique Observed': { data: [], name: 'Technique Observed', id: 'Technique Observed' },
    Event: { data: [], name: 'Event', id: 'Event' },
    'Host Command': { data: [], name: 'Host Command', id: 'Host Command' },
    'Malicious Executable': { data: [], name: 'Malicious Executable', id: 'Malicious Executable' },
    X509: { data: [], name: 'X509', id: 'X509' },
    'Phishing Email': { data: [], name: 'Phishing Email', id: 'Phishing Email' },
  }

  // early escape if no timeline object exists or if expected keys are missing from timeline object

  const techniqueHasTimeline = !isEmpty(technique.timeline)
  if (!techniqueHasTimeline) return new Map()
  const timelineKeys = Object.keys(technique.timeline)
  const timelineOverviewKeys = Object.keys(timelineOverviewObject)
  const timelineOverviewKeysExist = timelineKeys.some((key) => timelineOverviewKeys.includes(key))
  if (!timelineOverviewKeysExist) return new Map()

  const timelineOverviewMap = new Map(Object.entries(timelineOverviewObject))

  const { timeline = {} } = technique
  if (isEmpty(timeline)) return null
  for (const item in timeline) {
    const itemArray = Array.isArray(timeline[item]) ? timeline[item] : [timeline[item]]
    if (item === 'Technique Observed') {
      for (const [i, event] of itemArray.entries()) {
        const { used_by: usedBy = [], ...rest } = event
        if (usedBy.length > 0) {
          usedBy.forEach((actor, j) => {
            if (actor?.first_observed && actor?.releasable) {
              const updatedTimestamp = parseISO(actor.first_observed.slice(0, -5))
              // adding n minutes to avoid overlapping events
              const updatedDate = addMinutes(updatedTimestamp, (i + j) * 0.5).toISOString()
              const data = {
                timestamp: updatedTimestamp,
                x: updatedDate,
                y: 0,
                actor: actor.actor,
                id: `${i}-${j}-${rest.name || rest.description}`,
                ...rest
              }
              timelineOverviewMap.get('Technique Observed').data.push(data)
            }
          })
        }
      }
    }
    if (item === 'Event') {
      createEventMap(itemArray, timelineOverviewMap, 'Event')
    }
    if (item === 'Host Command') {
      createEventMap(itemArray, timelineOverviewMap, 'Host Command')
    }
    if (item === 'X509') {
      createEventMap(itemArray, timelineOverviewMap, 'X509')
    }
    if (item === 'Phishing Email') {
      createEventMap(itemArray, timelineOverviewMap, 'Phishing Email')
    }
    if (item === 'Malicious Executable') {
      createEventMap(itemArray, timelineOverviewMap, 'Malicious Executable')
    }
  }

  const mergedDataWithBounds = getBounds([
    ...timelineOverviewMap.get('Event').data,
    ...timelineOverviewMap.get('Host Command').data,
    ...timelineOverviewMap.get('Technique Observed').data,
    ...timelineOverviewMap.get('X509').data,
    ...timelineOverviewMap.get('Phishing Email').data,
    ...timelineOverviewMap.get('Malicious Executable').data
  ])
    .map((point, index) => {
      // if index is 0, then it is the first point, set the iso time to 00:00:00
      if (index === 0) {
        point.x = point.x.slice(0, 11) + '00:00:00.000Z'
      }
      return {
        timestamp: point?.timestamp,
        x: point?.x,
        y: 0,
        name: point?.name || point?.description,
        transparent: true,
      }
    })
  timelineOverviewMap.forEach((value, key) => {
    const sortedData = sortBy(value.data, 'timestamp')
    const clonedIndex0 = { ...mergedDataWithBounds[0], name: key }
    const clonedIndex1 = { ...mergedDataWithBounds[1], name: key }
    sortedData.unshift(clonedIndex0)
    sortedData.push(clonedIndex1)
    value.data = sortedData
    value.hasData = sortedData.length > 2
  })
  return timelineOverviewMap
}
